import React from 'react';
import { LastNameField } from './components/LastNameField';
import { ArizonaLicenseField } from './components/ArizonaLicenseField';
import { FirstNameField } from './components/FirstNameField';
import { DateOfBirthField } from '../DateOfBirthField';

export const NameAndLicensePanel: React.FC = () => {
    return (
        <>
            <div className='field-section'>
                <div className='field-row'>
                    <FirstNameField />
                    <LastNameField />
                </div>
                <div className='field-row'>
                    <DateOfBirthField />
                    <ArizonaLicenseField />
                </div>
            </div>
        </>
    );
};
